import type { Feature } from "geojson";

import { updateCoordinates } from "@/features/geojson_editor/libs/updateCoordinates";
import { createEditorMetaFromFeature } from "@/features/geojson_editor/meta";
import { BaseMode } from "@/features/geojson_editor/modes/BaseMode";

export class BatchSelectMode extends BaseMode {
  generateMetaFeatures(): Feature[] {
    if (!this.shouldRecalculateMetaFeatures()) {
      return this._cachedMetaFeatures;
    }

    const features = Object.values(this._features).flatMap((f) =>
      createEditorMetaFromFeature(f, {
        includeCenterPoint: false,
        includeFill: true,
        includeLine: true,
        includeVertex: false,
      }),
    );
    this._cachedMetaFeatures = features;
    return features;
  }

  eventHandlers: BaseMode["eventHandlers"] = {
    onFillDrag: (e) => {
      const { displacement } = e;
      const updatedFeatures = Object.values(this._features).reduce(
        (acc: Record<string, Feature>, feature) => {
          acc[feature.id] = updateCoordinates(feature, (coord) => {
            const [lng, lat, ...rest] = coord;
            return coord.length >= 2
              ? [lng + displacement.lng, lat + displacement.lat, ...rest]
              : coord;
          });
          return acc;
        },
        {},
      );
      this.onChange({ updated: updatedFeatures }, true);
      return true;
    },
  };
}
